export default {
      id: "oc-dingtalk-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dingtalk",
      toString: function () {
        return this.url;
      }
    }